import React from 'react';
import { Pagination } from 'antd';

import styled from 'styled-components';

const PaginationWrapper = styled.div`
  .ant-pagination {
    margin-bottom: 5px;
    margin-top: 5px;
  }
  .ant-pagination-options {
    display: none;
  }
`;

const PaginationBlock = ({
  data,
  onChange,
}: {
  data: { pageNumber?: number; maxResultPage?: number; maxPages?: number };
  onChange: (page: number, pageSize?: number) => void;
}) => {
  return (
    <PaginationWrapper>
      <Pagination
        current={data?.pageNumber}
        pageSize={data?.maxResultPage ? data?.maxResultPage : 0}
        total={data && data.maxResultPage && data.maxPages ? data.maxResultPage * data.maxPages : undefined}
        onChange={onChange}
      />
    </PaginationWrapper>
  );
};

export default PaginationBlock;
